import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import api from "../../api";

const DynamicEvents = () => {
  const [events, setEvents] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [sliderRef, setSliderRef] = useState(null);

  useEffect(() => {
    api.get("api/home-events")
      .then(res => {
        setEvents(res.data);
        if (res.data.length > 0) {
          setSelectedImage(res.data[0].image);
        }
      })
      .catch(err => console.error(err));
  }, []);

  // Function to convert 24-hour time to 12-hour format with AM/PM
  const convertTo12Hour = (time24) => {
    if (!time24) return "";
    
    const [hours, minutes] = time24.split(':');
    let hour = parseInt(hours, 10);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    
    hour = hour % 12;
    hour = hour === 0 ? 12 : hour; // Convert 0 to 12 for 12 AM
    
    return `${hour}:${minutes} ${ampm}`;
  };

  const handleEventClick = (imageUrl, index) => {
    setSelectedImage(imageUrl);
    if (sliderRef) {
      sliderRef.slickGoTo(index);
    }
  };

  // Slider settings
  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    fade: true,
    arrows: false,
    afterChange: (current) => {
      if (events[current]) {
        setSelectedImage(events[current].image);
      }
    }
  };

  if(events.length === 0) return <></>;

  return (
    <section className="event-style1-area">
      <div className="container">
        <div className="sec-title text-center pt-0">
          <h2>Upcoming Events</h2>
        </div>
        <div className="row">
          {/* Left Image Slider */}
          <div className="col-lg-6 mb-4 mb-lg-0">
            <div className="image-display-box text-center h-100">
              {events.length > 0 ? (
                <Slider 
                  ref={setSliderRef}
                  {...sliderSettings}
                >
                  {events.map((event, index) => (
                    <div key={event.id}>
                      <img 
                        alt={event.title} 
                        className="img-fluid w-100" 
                        src={`${process.env.REACT_APP_API_URL}/public/${event.image}`}
                        style={{ 
                          objectFit: "cover", 
                          height: "400px",
                          borderRadius: "8px"
                        }} 
                      />
                    </div>
                  ))}
                </Slider>
              ) : (
                <p>No events available</p>
              )}
            </div>
          </div>

          {/* Right Events List */}
          <div className="col-lg-6 d-flex flex-column justify-content-center">
            <div className="event-style1-content-box">
              <ul>
                {events.map((event, index) => (
                  <li 
                    key={event.id} 
                    onClick={() => handleEventClick(event.image, index)} 
                    style={{ cursor: "pointer" }}
                    className={selectedImage === event.image ? "active-event" : ""}
                  >
                    <div className="overlay-icon">
                      <span className="icon-play-button-1"></span>
                    </div>
                    <div className={`single-event-box-style1 ${index % 2 === 0 ? "single-event-box-style1--style2" : ""}`}>
                      <div className="date-box">
                        <h2>{new Date(event.event_date).getDate()}</h2>
                        <p>
                          {new Date(event.event_date).toLocaleDateString("en-US", { month: "short", year: "numeric" })}
                        </p>
                      </div>
                      <div className="title-box">
                        <div className="event-time">
                          <i className="fa fa-clock-o" aria-hidden="true"></i>
                          <p>
                            {convertTo12Hour(event.start_time)} - {convertTo12Hour(event.end_time)}
                          </p>
                        </div>
                        <h3>
                          {event.title}
                        </h3>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DynamicEvents;